module.exports = __webpack_public_path__ + "static/img/icon.288d34bb.png";